import React from 'react';
import { CTAButton } from './CTAButton';
import { DumbbellIcon, ShieldIcon, StarIcon } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/rvX61FSTSXRtWcXvGnJkpT/ChatGPT-Image-14-jul-2026_-08_19_46-p.m..webp';
export function Hero() {
  return <section className="pt-6 pb-5 px-4 sm:px-6 bg-white text-center border-b-4 border-brand-ivory" data-id="element-89">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-violet/10 border border-brand-violet/20 text-brand-navy font-heading font-bold text-[11px] sm:text-xs mb-3" data-id="element-90">
        <DumbbellIcon className="w-3.5 h-3.5 text-brand-violet" data-id="element-91" />
        <span className="tracking-wide uppercase" data-id="element-92">
          Pour les Professeurs de Gymnastique Artistique
        </span>
      </div>
      <h1 className="text-2xl sm:text-4xl font-heading font-extrabold text-brand-navy leading-tight mb-3" data-id="element-93">
        Le Système Complet de Planification pour les Professeurs de Gymnastique
        Artistique
      </h1>
      <p className="text-sm sm:text-lg text-brand-text font-medium leading-snug mb-4 max-w-xl mx-auto" data-id="element-94">
        Gagnez des heures de préparation chaque semaine grâce à un système
        professionnel conçu pour planifier vos entraînements, construire des
        progressions techniques, organiser votre saison et préparer des séances
        complètes de gymnastique artistique — sans devoir tout créer à partir de
        zéro.
      </p>
      <a href="#pricing" className="block cursor-pointer mb-4" aria-label="Voir l'offre Gymnastique Pro" data-id="element-95">
        <img src={PRODUCT_IMG} alt="GYMNASTIQUE PRO, le système complet de planification 6-en-1 pour les professeurs de gymnastique artistique" className="w-full h-auto object-contain max-w-[390px] sm:max-w-md mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-96" />
      </a>
      <div className="mb-3" data-id="element-97">
        <CTAButton href="#pricing" data-id="element-98">
          🚀 OUI ! JE VEUX MON SYSTÈME MAINTENANT
        </CTAButton>
      </div>
      <div className="flex flex-col sm:flex-row justify-center items-center gap-1.5 sm:gap-4 text-xs sm:text-sm text-brand-text font-bold" data-id="element-99">
        <div className="flex items-center gap-1.5" data-id="element-100">
          <StarIcon className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-101" />
          <span data-id="element-102">
            4,9/5 — Avis vérifiés de professeurs de gymnastique artistique
          </span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-103">
          <ShieldIcon className="w-4 h-4 text-brand-violet" data-id="element-104" />
          <span data-id="element-105">
            Garantie satisfait ou remboursé pendant 7 jours — Zéro risque
          </span>
        </div>
      </div>
    </section>;
}